document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.swiper.collection-slider').forEach(slider => {
    const swiper = new Swiper(`#${slider.id}`, {
      loop: true,
      slidesPerView: 2,
      navigation: {
        enabled: false
      },
      pagination: {
        enabled: true,
        el: `#${slider.id} .swiper-pagination`,
        type: 'bullets',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 11,
        },
        // when window width is >= 640px
        990: {
          slidesPerView: 4,
          spaceBetween: 20,
          navigation: {
            enabled: true
          },
          pagination: {
            enabled: false
          }
        }
      },
    });
    document.querySelector(`#${slider.id} .swiper-button-prev`)?.addEventListener('click', () => {
      swiper.slidePrev()
    })
  
    document.querySelector(`#${slider.id} .swiper-button-next`)?.addEventListener('click', () => {
      swiper.slideNext()
    })
  })
})
